// Modules:
import React, { useState, useEffect } from 'react';

// Utils:
import { useErrorHandler } from 'react-error-boundary';
import { handleFetchError } from 'utilities/utils';

// Config:
import config from 'config/config';

// Router:
import { NavLink } from 'react-router-dom/';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';

// Components:
import TopicsDrawer from './TopicsDrawer';

const styles = {
    '&.MuiAccordion-root': {
        backgroundColor: 'black',
        color: 'white',
    },
    '&.MuiAccordionSummary-root': {
        width: '100%',
        paddingLeft: '0.6rem',
        paddingRight: '0.6rem',
    },
};

const Navbar = ({ routerParams, handleErrorReset }) => {
    const [navbarContent, setNavbarContent] = useState({});

    // // Error Hook // //
    const handleError = useErrorHandler();

    // // Effects // //
    // Fetch editable content for the navbar
    useEffect(() => {
        const getNavbarContent = () => {
            fetch(`${config.navbarContentEndpoint}`)
                .then(handleFetchError)
                .then((res) => res.json())
                .then((json) => setNavbarContent(json), handleError)
                .catch(handleError);
        };
        getNavbarContent();
    }, [handleError]);

    const navbarTitle = navbarContent?.find?.((x) => x.name === 'navbar title')
        ?.content;

    const navbarSubTitle = navbarContent?.find?.(
        (x) => x.name === 'navbar subtitle'
    )?.content;

    const hamburgerLinks = navbarContent?.filter?.(
        (x) => x.name === 'navbar hamburger item'
    );

    return (
        <div className="navbar">
            <Accordion sx={styles} expanded={false}>
                <AccordionSummary
                    sx={styles}
                    expandIcon={
                        routerParams.topic ? (
                            <TopicsDrawer
                                routerParams={routerParams}
                                hamburgerLinks={hamburgerLinks ?? []}
                            />
                        ) : null
                    }
                    aria-controls="panel1a-content"
                    id="navbar-header"
                >
                    <div className="mdh-header">
                        <button
                            type="button"
                            className="navbar-button"
                            onClick={handleErrorReset}
                        >
                            <NavLink
                                to="/"
                                activeStyle={{ textDecoration: 'none' }}
                            >
                                <img
                                    className="md-logo"
                                    src="/ephtportal/images/release_header.png"
                                    alt="maryland-flag-logo"
                                />
                            </NavLink>
                            <NavLink
                                to="/"
                                activeStyle={{ textDecoration: 'none' }}
                            >
                                <div className="app-title-container">
                                    <p className="app-title">
                                        {/* Providing fallbacks for title and subtitle to aid if api calls fail */}
                                        {navbarTitle ??
                                            'Maryland Department of Health -'}
                                    </p>
                                    <p className="app-title byline">
                                        {navbarSubTitle ??
                                            'Environmental Public Health Tracking'}
                                    </p>
                                </div>
                            </NavLink>
                        </button>
                    </div>
                </AccordionSummary>
            </Accordion>
        </div>
    );
};
export default Navbar;
